module.exports = __webpack_public_path__ + "img/tomato_small_color.cc90d8a5.svg";